import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="faq"
      className="scroll-mt-16 border-y border-secondary-200 bg-background-100"
    >
      <div className="mx-auto max-w-4xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <span className="text-stamp text-xs text-primary-600">HOW TO READ</span>
          <h3 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">
            查证答疑 · 该怎么用这份归档
          </h3>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
            关于排序、检索与更新机制，先看这里再动手，效率更高。
          </p>
        </div>

        <div className="mt-7 grid gap-3 md:mt-8">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? 'border-primary-200 bg-background-50' : 'border-secondary-200 bg-background-50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center gap-3 px-5 py-4 text-left"
                >
                  <span className="font-heading flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-800">
                    Q
                  </span>
                  <span className="flex-1 text-sm font-bold text-foreground-950">{f.q}</span>
                  <i
                    className={`text-lg text-foreground-500 transition-transform ${
                      open ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  />
                </button>
                {open && (
                  <div className="flex gap-3 px-5 pb-5 pt-0 pl-[52px]">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}